
import { defineComponent } from 'vue';

// Components
import SearchBar from '@/components/SearchBar/SearchBar.vue';
import RecentSearch from '@/components/RecentSearch/RecentSearch.vue';

// Types
import { RecentSearch as RecentSearchType } from '@/types/search-results.types';

export default defineComponent({
  name: 'Home',
  components: {
    SearchBar,
    RecentSearch
  },
  data() {
    return {
      searchQuery: '',
      recentSearches: [] as RecentSearchType[],
      doggiesAdjectives: ['tiernos', 'lindos', 'preciosos', 'memes', 'chistosos', 'gatitos', 'grandes', 'durmiendo', 'acostados', 'bobos']
    };
  },
  methods: {
    onSearchChange(e: InputEvent) {
      this.searchQuery = (e.currentTarget as HTMLInputElement).value;
    },
    onSearchSubmit() {
      this.recentSearches.push({
        id: `${this.searchQuery.split(' ').join('_')}_${this.searchQuery.length}`,
        query: this.searchQuery,
        faved: false
      });

      localStorage.setItem('recentSearch', JSON.stringify(this.recentSearches));

      this.$router.push({
        path: '/search',
        query: {
          q: this.searchQuery
        }
      });
    },
    onFavClick(event: MouseEvent, el: RecentSearchType) {
      const selectedElIndex = this.recentSearches.findIndex(r => r.id === el.id);

      if (selectedElIndex !== -1) {
        this.recentSearches[selectedElIndex].faved = !this.recentSearches[selectedElIndex].faved;

        localStorage.setItem('recentSearch', JSON.stringify(this.recentSearches));
      }
    },
    recentSearchLink(event: Event, recent: RecentSearchType) {
      const recentEl = this.recentSearches.find(el => el.id === recent.id);

      if (recentEl) {
        const search = new URLSearchParams({
          q: recentEl.query
        }).toString();

        return `/search?${search}`;
      }

      return undefined;
    }
  },
  mounted() {
    const recentSearches = localStorage.getItem('recentSearch');

    if (recentSearches) {
      this.recentSearches = JSON.parse(recentSearches);
    }
  }
});
